import _ from 'lodash/fp'
import { createActions, createTypes, createReducer } from './util'

export const namespace = 'guides'

const typeKeys = [
  'GUIDE_JSON_REQUEST',
  'FINISH_REQUEST',
  'SUCCESS_REQUEST',
  'ERROR_REQUEST',
  'REQUEST_SHOTS_FOR_GUIDE'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

export const initialState = {
  items: {}
}

const reducer = {
  [types.GUIDE_REQUEST]: () => _.set('waiting', true),
  [types.FINISH_REQUEST]: p => _.set('items.' + p.guide_id, p),
  [types.SUCCESS_REQUEST]: () => _.set('waiting', false),
  [types.ERROR_REQUEST]: () => _.set('waiting', false),
  [types.REQUEST_SHOTS_FOR_GUIDE]: () => _.identity // NOTE: this is intended to be not implemented, just to avoid future fires
}

export default createReducer(initialState, reducer)

function createSelectors () {
  const ns = _.get(namespace)
  const guides = _.flow(ns, _.get('items'))
  const guideById = id => _.flow(guides, _.get(id))
  return {
    guides,
    guideById
  }
}

export const selectors = createSelectors()
